/** Runtime configuration: `/config.json` in every deployed environment (written by the
 *  deploy step from Terraform outputs), `VITE_*` variables as the local fallback. */
export interface AppConfig {
  cognito_domain: string;
  cognito_client_id: string;
  /** Region of the user pool, for the direct sign-in calls. */
  cognito_region: string;
  api_base: string;
  environment: string;
}

let cached: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached;
  let fromFile: Partial<AppConfig> = {};
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (res.ok) fromFile = (await res.json()) as Partial<AppConfig>;
  } catch {
    // Local dev without a config file: fall through to the env.
  }
  const env = import.meta.env;
  cached = {
    cognito_domain: fromFile.cognito_domain || env.VITE_COGNITO_DOMAIN || "",
    cognito_client_id: fromFile.cognito_client_id || env.VITE_COGNITO_CLIENT_ID || "",
    cognito_region: fromFile.cognito_region || env.VITE_COGNITO_REGION || "",
    api_base: fromFile.api_base || "",
    environment: fromFile.environment || env.MODE,
  };
  return cached;
}

export function config(): AppConfig {
  if (!cached) throw new Error("config not loaded");
  return cached;
}
